var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-o-d-10-2023-any-object-report')}
var staticRenderFns = []

export { render, staticRenderFns }